export const feedBack = {
  SUCCESS_FETCHING_FEEDBACK_DETAILS_WIDGETS: 'SUCCESS_FETCHING_FEEDBACK_DETAILS_WIDGETS',
  FAILURE_FETCHING_FEEDBACK_DETAILS_WIDGETS: 'FAILURE_FETCHING_FEEDBACK_DETAILS_WIDGETS',
  SUCCESS_FETCHING_FEEDBACK_DETAILS_DATA: 'SUCCESS_FETCHING_FEEDBACK_DETAILS_DATA',
  FAILURE_FETCHING_FEEDBACK_DETAILS_DATA: 'FAILURE_FETCHING_FEEDBACK_DETAILS_DATA',
  START_ADDING_NOTE:'START_ADDING_NOTE',
  SUCCESS_ADDING_NOTE: 'SUCCESS_ADDING_NOTE',
  FAILURE_ADDING_NOTE: 'FAILURE_ADDING_NOTE'
};
